import { create } from "zustand";

export type Toast = {
  id: string;
  type: "success" | "error" | "info" | "warning";
  text: string;
  duration: number;
};

interface ToastState {
  toasts: Toast[];
  addToast: (type: Toast["type"], text: string, duration?: number) => void;
  removeToast: (id: string) => void;
}

const timeouts = new Map<string, ReturnType<typeof setTimeout>>();

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  addToast: (type, text, duration = 5000) => {
    const id = crypto.randomUUID();
    set((state) => ({
      toasts: [...state.toasts, { id, type, text, duration }],
    }));
    const handle = setTimeout(() => {
      timeouts.delete(id);
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
    }, duration);
    timeouts.set(id, handle);
  },
  removeToast: (id) => {
    const handle = timeouts.get(id);
    if (handle) {
      clearTimeout(handle);
      timeouts.delete(id);
    }
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
}));
